<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <v-card-title>{{ 'User Profile'| translate }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form id="form" ref="form">
                  <v-row>
                    <v-col cols="12" sm="8" md="8">
                      <v-row v-if="Object.keys(errors).length>0">
                        <v-col cols="12" sm="8" md="8">
                          <v-alert
                            dense
                            v-for="(v, k) in errors"
                            :key="k"
                            outlined
                            type="error"
                          >{{ k }} {{ v }}</v-alert>
                        </v-col>
                      </v-row>
                      <v-row v-else-if="typeof errors =='string'">
                        <v-col cols="12" sm="8" md="8">
                          <v-alert dense outlined type="error">{{ errors }}</v-alert>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="salutation"
                            :items="salutationvalues"
                            item-value="value"
                            item-text="name"
                            :label="'Salutation' | translate"
                            autocomplete="off"
                            name="salutation"
                            :rules="salutationRules"
                            outlined
                            required
                            :no-data-text="$t('No data available')"
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                            
                          </v-select>
                        </v-col>
                        <v-col cols="9" sm="9">
                          <v-text-field
                            outlined
                            :label=" 'Name' | translate"
                            v-model="name"
                            name="name"
                            :rules="nameRules"
                            autocomplete="off"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                            
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            outlined
                            :label="'Email' | translate"
                            v-model="email"
                            name="email"
                            :rules="emailRules"
                            autocomplete="off"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                            
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            outlined
                            :label="'Phone Number' | translate"
                            type="text"
                            v-model="phone_no"
                            name="phone_no"
                            class="phonenumber"
                            :rules="phoneRules"
                            autocomplete="off"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>  
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            outlined
                            name="address"
                            v-model="address"
                            :rules="addressRules"
                            autocomplete="off"
                            :label="'Address' | translate"
                          >
                        <template #message="{ message }">
                          {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                        </template>                            
                          </v-textarea>
                        </v-col>
                      </v-row>
                      <v-row v-if="Object.keys(currentUser).length !=0 && currentUser.company.account_type == 'on-demand'">
                        <v-col cols="12" sm="12">
                          <h2 class="pb-4">{{ 'All Cards'| translate }}</h2>
                          <v-divider></v-divider>
                        </v-col>
                      </v-row>
                      <v-row v-if="Object.keys(currentUser).length !=0 && currentUser.company.account_type == 'on-demand'">
                        <v-col cols="12" sm="12">
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <div id="card-element"></div>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-btn large block color="primary" v-on:click="purchase" dark>{{ 'Add Card'| translate }}</v-btn>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col v-for="(v, k) in stripeallcards" :key="k" cols="12" sm="4">
                              <v-card class="mx-auto" max-width="344">
                                <v-card-text>
                                  <div>xxxxxxxxxxxx{{v.card_last_four}}</div>

                                  <p class="display-1 text--primary">{{v.card_brand}}</p>
                                  <div class="text--primary">{{ (Object.keys(currentUser).length !=0 ?  currentUser.name : '') }}</div>
                                </v-card-text>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-radio-group v-model="v.is_default" :mandatory="false">
                                    <v-radio :label="'Primary' | translate" v-on:click="primaryCard(v.payment_method)" :value="v.is_default? v.is_default : ''"></v-radio>
                                  </v-radio-group>                                  
                                  <v-btn small color="error" v-on:click="openRemoveDialog(v.payment_method)">{{ 'Remove'| translate }}</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-btn dark fab fixed bottom right large color="pink" class="mx-2" @click="update">
      <v-icon>mdi-content-save</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">{{ 'Profile updated successfully' | translate }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">{{ 'Close' | translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cardadded" persistent max-width="350">
      <v-card>
        <v-card-title class="headline">{{ 'Card added successfully'| translate }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="cardadded = false">{{ 'Close'| translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Dialogbox
      @closing="closing"
      @deletecard="deletecard"
      :title="dialogboxtitle"
      :dialog="dialogstatus"
      :buttonTitle="dialogButtontitle"
      :deletecard="true"
      v-if="dialogstatus"
    />
  </v-content>
</template>

<script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import Dialogbox from "@/components/dialog/dialog";
import store from "@/store";
import {
  FETCH_STRIPE_SECRET_KEY,
  STRIPE_RESET_STATE,
  SET_STRIPE_CARD,
  UPDATE_USER,
  FETCH_STRIPE_ALL_CARDS,
  DELETE_CARD,
  RESET_STATE,
  CHECK_AUTH
} from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type";

export default {
  name: "Profile",
  async beforeRouteUpdate(to, from, next) {
    await store.dispatch(STRIPE_RESET_STATE);
    return next();
  },
  async beforeRouteEnter(to, from, next) {

  store.dispatch(RESET_STATE)
   if(store.state.auth.user.company.account_type == "on-demand"){
      await store.dispatch(FETCH_STRIPE_SECRET_KEY, "setup-intent").then(resp => {
        if (resp.success) {
          store.commit(SET_LOADING, false);
        }
      }); 
   }



    if (
      store.state.auth.user.card_brand !== null &&
      store.state.auth.user.company.account_type == "on-demand"
    ) {
      await store.dispatch(FETCH_STRIPE_ALL_CARDS, "list-card").then(resp => {
        if (resp.success) {
          store.commit(SET_LOADING, false);
        }
      });
    }

    store.commit(SET_ROUTER_ENTER, false)

    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(STRIPE_RESET_STATE);
    next();
  },
  computed: {
    ...mapGetters(["stripesecretkey", "stripeallcards", "currentUser", 'curLanguage']),
    salutationvalues(){
      let salutationData = [
        { value: "Mr", name: this.$t("Mr") },
        { value: "Mrs", name: this.$t("Mrs") }
      ]
      return salutationData
    },  
    nameRules(){ 
      return [v => !!v || "Name is required"]
    },
    salutationRules(){ 
      return [v => !!v || "Salutation is required"]
    },
    emailRules(){ 
      return [v => /.+@.+/.test(v) || "Invalid Email address"]
    },
    phoneRules(){ 
      return [
        v => !!v || "Phone Number is required",
        v => Number.isInteger(Number(v)) || "The value must be an integer number"
      ]
    },
    addressRules(){ 
      return [v => !!v || "Address is required"]
    },
    pobRules() { 
      return [v => !!v || "Place of birth is required"]
    },
    dobRules(){ 
      return [v => !!v || "Date of birth is required"]
    },
    ...mapState({
      errors: state => state.users.usererrors,
    })
  },
  data: function() {
    return {
      name: null,
      salutation: null,
      phone_no: null,
      email: null,
      address: null,
      user_id: null,
      place_of_birth: null,
      date_of_birth: null,
      deletecardid: null,
      dialog: false,
      cardadded: false,
      radios: 'radio-1',
      stripe: "",
      elements: "",
      card: "",
      dialogstatus: false,
      dialogButtontitle: null,
      dialogboxtitle: null,

    };
  },
  created() {
    this.name = this.currentUser.name;
    this.salutation = this.currentUser.salutation;
    this.email = this.currentUser.email;
    this.address = this.currentUser.address;
    this.phone_no = this.currentUser.phone_no;
    this.user_id = this.currentUser.user_id;
    this.place_of_birth = this.currentUser.place_of_birth;
    this.date_of_birth = this.currentUser.date_of_birth;
  },
  mounted() {
    if (this.currentUser.company.account_type == "on-demand") {
      this.includeStripe(
        "js.stripe.com/v3/",
        function() {
          this.configureStripe();
        }.bind(this)
      );
    }
  },
  components: {
    Dialogbox
  },
  methods: {
    closing() {
      this.dialogstatus = false;
    },
    openRemoveDialog(card) {
      this.dialogstatus = true;
      this.dialogboxtitle = "Are you sure want to remove?";
      this.dialogButtontitle = "Remove";
      this.deletecardid = card
    },
    async deletecard() {
      await this.$store
        .dispatch(DELETE_CARD, "payment-method/delete/"+this.deletecardid)
        .then(async resp => {
          if (resp !=undefined && resp.success) {
            this.deletecardid = null;
            await store.dispatch(FETCH_STRIPE_ALL_CARDS, "list-card").then(resp => {
              if (resp.success) {
                store.commit(SET_LOADING, false);
                this.dialogstatus = false;
              }
              else {
                store.commit(SET_LOADING, false);
                this.dialogstatus = false;
              }
            });
          }
          else{
            store.commit(SET_LOADING, false);
          }
        });
    },
    includeStripe(URL, callback) {
      let documentTag = document,
        tag = "script",
        object = documentTag.createElement(tag),
        scriptTag = documentTag.getElementsByTagName(tag)[0];
      object.src = "//" + URL;
      if (callback) {
        object.addEventListener(
          "load",
          function(e) {
            callback(null, e);
          },
          false
        );
      }
      scriptTag.parentNode.insertBefore(object, scriptTag);
    },
    primaryCard(paymentmethod) {
      let params = { is_default: "true", payment_method: paymentmethod };
      this.$store.dispatch(SET_STRIPE_CARD, params).then(resp => {
        if (resp !=undefined && resp.success) {
            Promise.all([
              store.dispatch(FETCH_STRIPE_SECRET_KEY, "setup-intent"),
              store.dispatch(FETCH_STRIPE_ALL_CARDS, "list-card").then(resp => {
              if (resp.success) {
                store.commit(SET_LOADING, false);
              }
              else {
                store.commit(SET_LOADING, false);
              }
            }),
            ]).finally(() => {
              store.commit(SET_LOADING, false)
            })
        }
        else{
          store.commit(SET_LOADING, false)
        }
      });
    },
    update() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch(UPDATE_USER, {
            email: this.email,
            name: this.name,
            address: this.address,
            phone_no: this.phone_no,
            salutation: this.salutation,
            user_id: this.user_id,
            _method: "put"
          })
          .then(resp => {
            if (resp != undefined && resp.success) {
              store.dispatch(CHECK_AUTH).then( resp =>{
                if(resp !== undefined && resp.hasOwnProperty('success') && resp.success == true){
                  store.commit(SET_LOADING, false)
                  this.dialog = true;
                  this.$store.dispatch(RESET_STATE)
                }
              })


              this.dialog = true;
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
      }
    },
    async purchase() {
      const { setupIntent, error } = await this.stripe.confirmCardSetup(
        this.stripesecretkey,
        {
          payment_method: {
            card: this.card,
            billing_details: { name: this.currentUser.name }
          }
        }
      );
      if (!error) {
        let params = {
          is_default: "true",
          payment_method: setupIntent.payment_method
        };
        this.$store.dispatch(SET_STRIPE_CARD, params).then(resp => {
          if (resp.success) {
            this.cardadded = true;
            this.card.clear();
            Promise.all([
              store.dispatch(FETCH_STRIPE_SECRET_KEY, "setup-intent"),
              store.dispatch(FETCH_STRIPE_ALL_CARDS, "list-card").then(resp => {
              if (resp.success) {
                store.commit(SET_LOADING, false);
                this.dialogstatus = false;
              }
              else {
                store.commit(SET_LOADING, false);
                this.dialogstatus = false;
              }
            }),
            ]).finally(() => {
              store.commit(SET_LOADING, false)
            })

          }
        });
      }
    },
    configureStripe() {
      this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_API_TOKEN)

      this.elements = this.stripe.elements();
      this.card = this.elements.create("card");

      this.card.mount("#card-element");
    }
  }
};
</script>
